import moment from "moment";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { AppIcons } from "../constants/app-icons";
export default class MessagesService extends ApiService {
  template = "defaultTemplate";
  namespace = "messages";
  listingRelations = "peopleCount";
  relations = "?expand=peopleSimple,files,files.file,files.file.commentsCount";
  icon = "Announcement";
  favicon = "Announcement";
  DOMAIN = -3;
  action = "action";
  enableSchedular = true;
  search = true;
  singular = this.terminology.message.singular;
  plural = this.terminology.message.plural;
  vowel = this.terminology.message.vowel;
  name = `${this.vowel} ${this.singular}`;
  Width = 1200;
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: this.t("addAnEntity", {
        entity: this.terminology.messageTemplate.singular,
      }),
      icon: AppIcons.PLUS,
      services: 211,
    },
    {
      key: "listing",
      label: this.t("allEntity", {
        entity: this.terminology.messageTemplate.plural,
      }),
      icon: AppIcons.BULLETS,
      services: 211,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit " + this.name,
      icon: AppIcons.EDIT,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.TAG,
      field: "display_name",
    },
    {
      header: this.t("numberOfPeople"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "peopleCount",
    },
    {
      header: this.t("schedule"),
      icon: AppIcons.ALARM,
      field: "schedule_time",
      template: (data) => {
        return data.schedule_time > 0
          ? moment.unix(data.schedule_time).format("MM/DD/YYYY HH:ii")
          : "Send Now";
      },
    },
    {
      header: this.t("status"),
      icon: AppIcons.ANNOUNCEMENT,
      field: "is_sent",
      template: (data) => {
        return !data.is_sent
          ? "Pending (Queued)"
          : data.is_sent == 1
            ? "Sent"
            : "Declined";
      },
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.created_at).format("MM/DD/YYYY");
      },
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a new message",
      icon: AppIcons.PLUS,
    },
  ];
  getActionMenu(item) {
    let listMenuItems = [
      {
        key: "edit",
        label: "Edit this Message",
        icon: AppIcons.EDIT,
      },
      {
        key: "status",
        label: 1 == item.status ? "inactiveThisEntity" : "activeThisEntity",
        icon: 1 == item.status ? AppIcons.DISABLE : AppIcons.ENABLED,
      },
    ];
    return listMenuItems;
  }
  filterItems = [];
  constructor() {
    super("messages");
  }
}
